import React, { useState, useEffect } from 'react';
import { Tab, Nav, ListGroup, Row, Col, Card } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import DashboardLayout from '../pages/dashboard/DashboardLayout';
import { fetchSubjectCategories } from '../api/api';

const SubjectCategoryList = ({ favoritesOnly }) => {
    const [pageMessage, setPageMessage] = useState("Buscando atividades...");
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [subjects, setSubjects] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const getSubjects = async () => {
            try {
                const data = await fetchSubjectCategories(favoritesOnly);
                setSubjects(data);

                if (data.length === 0) {
                    setPageMessage(
                        <span>
                            Nenhuma atividade encontrada, adicione uma nova atividade <Link to="/dashboard/activity/add" style={{ color: '#0d6efd', fontWeight: 'bold', textDecoration: 'underline' }}>aqui</Link>
                        </span>
                    );
                }
            } catch (error) {
                console.error('Error fetching subjects:', error);
                setPageMessage("Erro ao buscar atividades.");
            }
        };

        getSubjects();
    }, [favoritesOnly]);

    const handleSubjectClick = (subject) => {
        setSelectedSubject(subject);
    };

    const handleCategoryClick = (category) => {
        let url = `/dashboard/category/${category.uuid}`;
        if (favoritesOnly) {
            url += '?favorites_only=true';
        }
        navigate(url);
    };

    return (
        <div>
            <DashboardLayout title={favoritesOnly ? "Atividades Favoritas" : "Todas Atividades"}>
                {subjects.length > 0 ? (
                    <Tab.Container id="subject-tabs" defaultActiveKey={subjects[0].uuid}>
                        <Row>
                            <Col sm={3}>
                                <Nav variant="pills" className="flex-column mb-5">
                                    {subjects.map(subject => (
                                        <Nav.Item key={subject.uuid}>
                                            <Nav.Link eventKey={subject.uuid} onClick={() => handleSubjectClick(subject)}>
                                                {subject.name}
                                            </Nav.Link>
                                        </Nav.Item>
                                    ))}
                                </Nav>
                            </Col>
                            <Col sm={3}>
                                <Tab.Content>
                                    {subjects.map(subject => (
                                        <Tab.Pane key={subject.uuid} eventKey={subject.uuid}>
                                            {subject.grades.map(grade => (
                                                <Card className="mb-4 shadow-sm" key={grade.name}>
                                                    <Card.Body>
                                                        <Card.Title>{grade.name}</Card.Title>
                                                        <ListGroup variant="flush">
                                                            {grade.categories.map(category => (
                                                                <ListGroup.Item action onClick={() => handleCategoryClick(category)} key={category.uuid}>
                                                                    {category.name}
                                                                </ListGroup.Item>
                                                            ))}
                                                        </ListGroup>
                                                    </Card.Body>
                                                </Card>
                                            ))}
                                        </Tab.Pane>
                                    ))}
                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                ) : (
                    <p>{pageMessage}</p>
                )}
            </DashboardLayout>
        </div>
    );
};

export default SubjectCategoryList;
